<template>
  <div class="page activity-rule">
    <navigation class="header">活动规则</navigation>
    <div class="body">
      <div class="activity-time">
        活动时间：长期有效
      </div>
      <div class="section" v-for="(item, index) in rules" :key="index">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="desc">
          {{ item.desc }}
        </div>
      </div>
    </div>
    <footer>活动所有解释权归天美贷所有</footer>
  </div>
</template>

<script>
export default {
  name: 'activity-rule',
  data () {
    return {
      start: Number(this.$route.query.start),
      end: Number(this.$route.query.end),
      rules: [
        // {
        //     title: '活动时间',
        //     desc: '长期有效'
        // },
        {
          title: '活动对象',
          desc: '天美贷所有注册用户。'
        },
        {
          title: '活动赔付方式',
          desc:
            '活动期间，参与「拒就赔」活动用户，申请授信拒绝可获得赔偿红包。'
        },
        {
          title: '红包领取方式',
          desc:
            '进入「拒就赔」活动页面获得现金红包，红包金额不等；确认绑卡信息后，红包支持提现至绑卡账户。活动期间每个用户仅能获得1次赔付。'
        }
      ]
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/mixin.less";

.page.activity-rule {
    background-color: #5267c7;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .header {
        flex-shrink: 0;
    }
    .body {
        flex: 1;
        flex-shrink: 0;
        .activity-time {
            margin: 68px 40px 47px 40px;
            font-size: 32px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: left;
            color: #ffffff;
            line-height: 45px;
        }
        .section {
            margin: 50px 40px 0px 40px;

            .title {
                padding: 18px 33px;
                border-radius: 16px;
                background-color: #4459b5;
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                line-height: 45px;
            }
            .desc {
                border-radius: 16px;
                background-color: #6779d2;
                padding: 18px 33px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                line-height: 40px;
                margin-top: 10px;
            }
        }
    }

    footer {
        flex-shrink: 0;
        font-size: 22px;
        color: rgba(221, 221, 221, 1);
        text-align: center;
        margin-bottom: 75px;
    }
}
</style>
